import { render, staticRenderFns } from "./notice-board-display.vue?vue&type=template&id=05b1cd6f&scoped=true"
import script from "./notice-board-display.vue?vue&type=script&lang=js"
export * from "./notice-board-display.vue?vue&type=script&lang=js"
import style0 from "./notice-board-display.vue?vue&type=style&index=0&id=05b1cd6f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05b1cd6f",
  null
  
)

export default component.exports